import { jsx as r } from "react/jsx-runtime";
import { createContext as l, useMemo as n, useContext as b } from "react";
const s = {
  enable_migration_trend_202504: !1,
  enable_entity_boundary_layer: !1,
  enable_all_basemap_items: !0,
  enable_esri_sourced_basemaps: !1,
  disableEsriBasemaps: !1
}, t = l(s), i = ({
  children: e,
  flags: a
}) => {
  const o = n(() => ({
    ...s,
    ...a
  }), [a]);
  return /* @__PURE__ */ r(t.Provider, { value: o, children: e });
}, p = () => b(t);
export {
  i as PLMapboxFlagsProvider,
  p as usePLMapboxFlags
};
//# sourceMappingURL=index.es43.js.map
